import React from 'react';
import gravatar from '../../../assets/images/gravatar.png'
export default function shopback(){
  return(
    <div className="post-1367 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
<div className="blog-single-post nosidebar">

  <section className="subpage-banner shopback-banner"></section>

  <div className="container">

    <div className="row">

      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-2">
                      
            <img src={gravatar} className="author-avatar img-circle img-responsive" alt="Avatar"/>            
                                  

          </div>          

          <div className="col-sm-10">

            <h2 className="post-title">ShopBack bags $25m in latest funding round</h2>
            <div className="row meta-info">
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-clock"></i>7 November 2017</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-comments"></i>No Comments</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-eye"></i>199 Views</span></div>
                            <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-tag"></i><a href="/news/" rel="category tag">News</a></span></div>
                          </div>

            <div className="post-article"><p>Singapore’s&nbsp;<a href="https://www.shopback.sg/" target="_blank" rel="noopener noreferrer">ShopBack</a>&nbsp;has just closed a funding round worth US$25 million, it announced today. It has raised a total of US$40 million in venture funding to date.</p>
<p>Fourteen investors participated in the round, which was led by Japanese credit card issuer and Mizuho Financial Group affiliate Credit Saison.</p>
<p>Among new backers to come on board were Thai telco Intouch, Singapore’s 33 Capital and Taiwan’s AppWorks. Existing investors that returned for this round included East Ventures, Qualgro, SoftBank, and Singtel.</p>
<p>The startup said this latest funding will be used to make hires and launch new product features.</p>
<p>Launching in 2014, ShopBack started out as a one-day flash sales site, similar to Groupon. Since then its business model has evolved to aggregating product listings from third-party ecommerce sites, which pay ShopBack a commission for each sale it generates for them.</p>
<p>ShopBack then passes some of this value back to online shoppers in the form of cashback, coupons, and discounts.</p>
<p>More recently, it has added service aggregation features for the ride-hailing and credit card payments verticals, said co-founder and CEO Henry Chan.</p>
<h2>$40m total funding revealed</h2>
<p>The startup claims that more than 3.5 million consumers have signed up to its service across the six Asia-Pacific markets it operates in. It also said it currently works with around 1,300 ecommerce partners in the retail, lifestyle, and travel segments, generating close to 1,000 orders per hour for them with an annualized sales figure&nbsp;of over US$300 million.</p>
<p>Moreover, it claims to have dished out almost US$15 million in cashback to online shoppers since launch.</p>
<p>In Southeast Asia it faces competition from a number of companies providing similar services – such as&nbsp;<a href="http://www.getperx.com/" target="_blank" rel="noopener noreferrer">Perx</a>&nbsp;– as well as in-house loyalty and rewards programs, including Grab’s GrabRewards, Lazada’s LiveUp, and Amazon’s Prime Now.</p>
<p>ShopBack had previously disclosed seed investments totaling US$1 million, including&nbsp;<a href="https://www.techinasia.com/shopback-cashback-online-shopping-raised-600k-investors">US$600,000</a>&nbsp;it raised in March 2015.</p>
<p>However, it today revealed that it has received a total of US$40 million in funding to date, inclusive of the just-closed US$25 million round.</p>
</div>

            <hr></hr>
            
            <div className="social-share">
              <div className="row">
                <div className="col-xs-6 share-text">Share</div>
                <div className="col-xs-6 share-button">
                  <div className="btn-group">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/shopback-bags-25m-in-latest-funding-round/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                    <a href="https://plus.google.com/share?url=https://33-capital.com/shopback-bags-25m-in-latest-funding-round/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-gplus"></i></a>
                    <a href="https://twitter.com/intent/tweet?text=ShopBack bags $25m in latest funding round&amp;url=https://33-capital.com/shopback-bags-25m-in-latest-funding-round/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-twitter"></i></a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/shopback-bags-25m-in-latest-funding-round/&amp;title=ShopBack bags $25m in latest funding round&amp;summary=Singapore’s ShopBack has just closed a funding round worth US$25 million, it announced today. It has raised a total of US$40 million in venture funding to date. Fourteen investors participated in the round, which was led by Japanese credit card issuer and Mizuho Financial Group affiliate Credit Saison. Among new backers to come on board were Thai&amp;source=https://33-capital.com/shopback-bags-25m-in-latest-funding-round/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin"></i></a>
                    <a href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/shopback-bags-25m-in-latest-funding-round/&amp;description=Singapore’s ShopBack has just closed a funding round worth US$25 million, it announced today. It has raised a total of US$40 million in venture funding to date. Fourteen investors participated in the round, which was led by Japanese credit card issuer and Mizuho Financial Group affiliate Credit Saison. Among new backers to come on board were Thai&amp;media=" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-pinterest"></i></a>
                  </div>                  
                </div>
              </div>
            </div>  
            <hr></hr>
                        <div className="comment-count">
              No Comments           </div>
            <hr></hr>
                        
          </div>
        
        </div>
       
      
      </div>

  

    </div>

  </div>

</div>
</div>

  )
}



// WEBPACK FOOTER //
// ./src/components/News/posts/shopback.js